import { useEffect } from 'react';
import { useCTVModal } from './useCTVModal';
import { useCTVPopupActions } from './useCTVPopupActions';
import { useIsVideoStateCTVEquivalent } from './useIsVideoStateCTVEquivalent';

export const useCTVPopup = () => {
  const shouldShowPopup = useIsVideoStateCTVEquivalent();
  const { showCTVModal } = useCTVModal();
  const { onConfirmed, onCancel } = useCTVPopupActions();

  useEffect(() => {
    if (shouldShowPopup)
      showCTVModal({
        onConfirmed: onConfirmed,
        onCancel: onCancel,
      });
  }, [shouldShowPopup, onConfirmed, onCancel, showCTVModal]);
};
